import { DocIcon, FileIcon, PdfIcon, RarIcon, SvgIcon, VideoIcon, ZipIcon } from './SVGIcon';

export const getFileIcon = (fileLink) => {
    // Extract the file extension from the link
    const fileExtension = fileLink.split('.').pop().toLowerCase();

    // check if the file is video type
    if (fileExtension === 'mp4' || fileExtension === 'mov' || fileExtension === 'avi') {
        return <VideoIcon />;
    }
    // Check if the file is an zip
    if (fileExtension === 'zip') {
        return <ZipIcon />;
    }
    // check if the file is an pdf
    if (fileExtension === 'pdf') {
        return <PdfIcon />;
    }

    // Check if the file is an svg
    if (fileExtension === 'svg') {
        return <SvgIcon />;
    }

    // Check if the file is an docx
    if (fileExtension === 'docx') {
        return <DocIcon />;
    }

    // Check if the file is an rar
    if (fileExtension === 'rar') {
        return <RarIcon />;
    }

    // Check if the file is an image
    if (['jpg', 'jpeg', 'png', 'gif'].includes(fileExtension)) {
        // For image files, return the img tag
        return (
            <img
                src={fileLink}
                alt="imagePeview"
                className="w-full h-full object-cover object-center rounded-5 block"
            />
        );
    }
    // For other file types, return the file extension
    return <FileIcon />;
};

export default null;
